module.exports = "/assets/data/5e5fd1cb60f328adf3f159ec7bde84b5-OX2.data.json";